export default __webpack_public_path__ + "static/media/bar_horizontal.0391c446.png";